import { mapActions, mapGetters } from 'vuex'

export default {
  methods: {
    ...mapActions({
      closeSidebar: 'ui/projectSidebar.close'
    }),
    showToast(message, config={}){
      this.toast = {...this.toastDefault, ...config}
      this.toast.message = message
      this.toast.show = true
    },
    init(){
      this.showToast("Fetching Project Information")
      this.$store.dispatch('equipments/all', {}); 
      this.findProject()
    },

    findProject(){
      return this.$store.dispatch('projects/find',{ id: this.projectId, config: this.projectQueryConfig }).then((res)=>{
        if(typeof(this.afterProjectLoad) == 'function'){
          this.afterProjectLoad(res.data)
        }
      })
    },

    setMode(modeType, equipmentId){
      this.$store.dispatch('sections/setCurrentMode', {mode: modeType, equipmentId: equipmentId});
      this.$store.dispatch('ui/projectSidebar.close')
    },

    resetMode(){
      this.$store.dispatch('sections/reset', {})
    },

    findSection(sectionId){
      this.$store.dispatch('sections/find', {})
    },
    
    openSidebar(type){
      let config = {
        component: "",
        heading: "",
        right: true,
        width: '300px',
        noHeader: true
      }
      
      switch(type){
        case 'roof-section-list':
          config = {
            ...config,
            width: "500px",
            component: "SectionsListDrawer",
            heading: this.$t("sidebar.titles.roof_section"),
          }
          
          break
        case 'assets-list':
          config = {
            ...config,
            component: "AssetsListDrawer",
            heading: this.$t("sidebar.titles.assets_list"),
            right: false
          }
          break;
        case 'equipments':
          config = {
            ...config,
            component: "SelectEquipmentDrawer",
            right: false,
          }
          break

        case 'equipment-list':
          config = {
            ...config,
            component: "EquipmentListDrawer",
            heading: this.$t("sidebar.titles.added_equipment"),
            width: '500px'
          }
          break
        case 'auto-identify':
          config = {
            ...config,
            component: "AutoIdentify",
            heading: this.$t("sidebar.titles.identification"),
            width: '320px'
          }
          break
        case 'project-settings':
          config = {
            ...config,
            component: "ProjectSetting",
            heading: this.$t("sidebar.titles.project_settings")
          }
          break
        case 'layers':
          config = {
            ...config,
            component: "Layers",
            heading: "Layers"
          }

      }
      
      this.$store.dispatch('ui/projectSidebar.open', config)
    }
  },

  computed: {
    ...mapGetters({
      'project': 'projects/item',
      'unit': 'projects/unit',
      'currentViewer': 'projects/currentViewer'
    }),

    projectId: function(){
      return this.$route.params.id
    },

    projectQueryConfig: function(){
      return (this.projectConfig || {})
    },

    assetDetails(){
      if(this.project){
        return ((this.project.asset || {}).asset_details || [])
      } else {
        return []
      }
    },

    orthoAssetDetail(){
      return this.assetDetails.filter(ad => ad.asset_type == 'OrthoImage')[0]
    },

    isDroneProject(){
      return (this.project || {}).asset_type == 'drone'
    }
  },

}